module.exports = __webpack_public_path__ + "img/icon_no_bg.5a0cb35a.png";